module.exports = __webpack_public_path__ + "media/customizations/myrtlecreek/logo-new-bb81e7744e6090ea5564705f66187a5a.png";